import { FilterType } from '../models/Filters';
import { getCustomPivotTabId } from './getCustomPivotTabId';
import { getFilterFunctionFromCustomPivot } from './getFilterFunctionFromCustomPivot';
export function getFilterModelFromCustomPivot(customPivot, tagMap, getTagIdByTagValue) {
    return {
        filterId: getCustomPivotTabId(customPivot),
        filterFunction: getFilterFunctionFromCustomPivot(customPivot, tagMap, getTagIdByTagValue),
        filterType: FilterType.Tabs,
        customFilterType: customPivot.customFilterType,
        customFilterKey: customPivot.customFilterKey,
        customFilterTitle: customPivot.customFilterTitle,
    };
}
//# sourceMappingURL=getFilterModelFromCustomPivot.js.map